<template>
  <div class="ddd">
    <TopNavBar />
    <div class="content-wrapper">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import TopNavBar from "@/components/TopNavBar.vue";
</script>

<style scoped>
.ddd {
  background-color: #f6f7f8;
  min-height: 100svh;
}
.content-wrapper {
  padding: 10px 120px 0 120px;
}
</style>
